import React from 'react';
import {Context} from '../Context'

import './Home.css'

import NavBar from './NavBar'
import ListContainer from './ListContainer'
import HashtagFilter from './HashtagFilter'

const HomePage = () =>
  <Context.Consumer>
  {
    ({globalState, actions}) =>
      <div className="home" style={{
          backgroundImage: `url('${globalState.theme.backgroundImage}')`,
          backgroundColor: globalState.theme.backgroundColor
        }}>
        <NavBar globalState={globalState} actions={actions} />
        <HashtagFilter
          globalState={globalState}
          actions={actions} />
        <ListContainer globalState={globalState} actions={actions} />
        <div className="footer">
          {globalState.user && <div><button className="signout-button" onClick={() => actions.signOut()}>Sign Out</button> - This is a beta test - UI will change.</div>}
        </div>
      </div>
  }
  </Context.Consumer>

export default HomePage;



// WEBPACK FOOTER //
// ./src/components/HomePage.js